import { call, put, takeEvery} from "redux-saga/effects";
import {
  GET_USER_ROLE_RELATIONS,
  ADD_USER_ROLE_RELATION,
  UPDATE_USER_ROLE_RELATION,
  DELETE_USER_ROLE_RELATION
} from "./actionTypes"

import {

  getUserRoleRelationSuccess,
  addUserRoleRelationSuccess,
  updateUserRoleRelationSuccess,
  deleteUserRoleRelationSuccess,
  userRoleRelationError
  
} from "./actions"

//Include Both Helper File with needed methods
import {

addUserRoleRelation,
updateUserRoleRelation,
deleteUserRoleRelation,
getUserRoleRelations

} from "../../../helpers/backend_helper/backend_helper"

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';


function* fetchUserRoleRelation() {
  try {
    const response = yield call(getUserRoleRelations)
    yield put(getUserRoleRelationSuccess(response))
  } catch (error) {
    yield put(userRoleRelationError(error))
  }
}

function* onAddUserRoleRelation({ payload: record }) {
  try {
    const response = yield call(addUserRoleRelation, record)
    yield put(addUserRoleRelationSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });

  } catch (error) {
    yield put(userRoleRelationError(error))
  }
}

function* onUpdateUserRoleRelation({ payload: record }) {
  try {
    const response = yield call(updateUserRoleRelation, record)
    yield put(updateUserRoleRelationSuccess(response))
  } catch (error) {
    yield put(userRoleRelationError(error))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });

  }
}

function* onDeleteUserRoleRelation({ payload: guid }) {
  try {
    const response = yield call(deleteUserRoleRelation, guid)
    yield put(deleteUserRoleRelationSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(userRoleRelationError(error))
  }
}


function* userRoleRelationManagementSaga() {

    yield takeEvery(GET_USER_ROLE_RELATIONS,fetchUserRoleRelation)
    yield takeEvery(ADD_USER_ROLE_RELATION,onAddUserRoleRelation)
    yield takeEvery(UPDATE_USER_ROLE_RELATION,onUpdateUserRoleRelation)
    yield takeEvery(DELETE_USER_ROLE_RELATION,onDeleteUserRoleRelation)
}

export default userRoleRelationManagementSaga
